<template>
  <div class="fill-height">
    <v-row align="center" justify="center" class="fill-height ma-0">
      <v-col class="text-center" cols="12">
        <div class="name-loja">
          <h1>{{ loja }}</h1>
        </div>
      </v-col>
      <v-col class="text-center px-5" cols="12">
        <img :src="img" :style="`width:${imgSize}px;max-width:${imgSize}px;margin-bottom:20px;`" class="emoji-bemvindo" />
        <h1>Bem-vindo{{clientName?', '+clientName:''}}!</h1>
        <p>
          {{ text }}
        </p>
        <v-btn rounded block depressed color="white" large class="mt-10 primary--text">
          <h2><b>Vamos Lá</b></h2>
        </v-btn>
      </v-col>
      <v-col cols="12"></v-col>
    </v-row>
    <v-footer app color="primary" class="text-center">
      <div class="fill-heigth max-width">
        <img src="@/assets/bemvindo/powered.png" />
        <img src="@/assets/bemvindo/comentaai.png" />
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  props: {
    loja: String,
    text: String,
    img: String,
    imgSize: String,
    clientName: String
  },
}
</script>

<style>
.name-loja {
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  display: inline-block;
}

.name-loja h2 {
  font-weight: normal;
}

.max-width {
  width: 100%;
}

.emoji-bemvindo {
  max-width: 120px;
  text-align: center;
  margin: auto auto;
}

.botao-bemvindo {
  /* color: #ff3366 !important; */
}
</style>
